import {
  Directive,
  HostListener,
  input,
  OnDestroy,
  output,
} from '@angular/core';

@Directive({
  selector: '[coreDebounceInput]',
  standalone: true,
})
export class DebounceInputDirective implements OnDestroy {
  debounceTime = input<number>(1000);
  debounceInput = output<Event>();

  private timeout: ReturnType<typeof setTimeout> | null = null;

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.debounceInput.emit(event);
    }, this.debounceTime());
  }

  ngOnDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
